import styled from 'styled-components'

export const ScrollButtons = styled.div`
  position: relative;

  & > .fa-chevron-left,
  & > .fa-chevron-right {
    position: absolute;
    bottom: -16px;
    background-color: #ffffff;
    width: 32px;
    height: 32px;
    border-radius: 100px;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & > .fa-chevron-left {
    &::before {
      transform: translate(-1px, 1px);
    }
  }

  & > .fa-chevron-right {
    right: 0;

    &::before {
      transform: translate(1px, 1px);
    }
  }
`
